export enum EventName {
	demo_fx_open_position = 'demo_fx_open_position',
	demo_fx_close_position = 'demo_fx_close_position',
	demo_complete_kyc = 'demo_complete_kyc',
	demo_send_documents = 'demo_send_documents',
	client_action = 'client_action',
	demo_fx_margin_call = 'demo_fx_margin_call',
	demo_fx_liquidation = 'demo_fx_liquidation',
	betb_risk_update = 'betb_risk_update',

	casino_bet_win = 'casino_bet_win',
	acc_deposit_approved = 'acc_deposit_approved',
	sport_bet_open = 'sport_bet_open',
	sport_bet_settled = 'sport_bet_settled',

	sport_bet_selection_open = 'sport_bet_selection_open',
	sport_bet_selection_settled = 'sport_bet_selection_settled',
}